import { useEffect } from 'react';

import noop from 'lodash/noop';

type Props = {
  container: HTMLElement | null;
  onTouchStart?: (event: TouchEvent) => void;
  onTouchMove?: (event: TouchEvent) => void;
  onTouchEnd?: (event: TouchEvent) => void;
  options?: AddEventListenerOptions;
  isDisabled?: boolean;
};

export const useTouchEvents = ({
  container,
  onTouchStart = noop,
  onTouchMove = noop,
  onTouchEnd = noop,
  options,
  isDisabled = false,
}: Props) => {
  useEffect(() => {
    if (isDisabled || !container) {
      return;
    }

    container.addEventListener('touchstart', onTouchStart, options);
    container.addEventListener('touchmove', onTouchMove, options);
    container.addEventListener('touchend', onTouchEnd, options);

    // eslint-disable-next-line consistent-return
    return () => {
      container.removeEventListener('touchstart', onTouchStart, options);
      container.removeEventListener('touchmove', onTouchMove, options);
      container.removeEventListener('touchend', onTouchEnd, options);
    };
  }, [isDisabled, onTouchEnd, onTouchMove, onTouchStart, options, container]);
};
